/**
 * Utility functions for handling JWT tokens
 */

/**
 * Check if the JWT token is expired
 * @returns {boolean} True if token is expired or invalid, false otherwise
 */
export const isTokenExpired = () => {
  try {
    // If it's a mocked external customer, token doesn't expire from client's context
    if (localStorage.getItem('IsExternalCustomer') === 'true') {
      return false;
    }

    const token = localStorage.getItem('Token');
    console.log('isTokenExpired check:', { tokenExists: !!token });

    // If no token exists, it's considered expired
    if (!token) {
      console.warn('isTokenExpired: No token found in localStorage');
      return true;
    }

    // Parse the JWT token
    const payload = parseJwt(token);
    console.log('isTokenExpired: payload parsed', {
      hasPayload: !!payload,
      exp: payload?.exp,
      currentTime: Math.floor(Date.now() / 1000)
    });

    // Check if the token has an expiration claim
    if (!payload || !payload.exp) {
      console.warn('isTokenExpired: Invalid payload or no exp claim');
      return true; // Consider invalid tokens as expired
    }

    // Get current time in seconds (JWT exp is in seconds)
    const currentTime = Math.floor(Date.now() / 1000);

    // Check if current time is past expiration
    const isExpired = payload.exp < currentTime;
    if (isExpired) console.warn('isTokenExpired: Token is expired');
    return isExpired;
  } catch (error) {
    console.error('Error checking token expiration:', error);
    return true; // Consider any parsing errors as expired tokens
  }
};

/**
 * Parse JWT token to get the payload
 * @param {string} token - JWT token string
 * @returns {Object|null} Parsed payload or null if invalid
 */
export const parseJwt = (token) => {
  try {
    // Split the token and get the payload part (second part)
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    // Decode the base64 string
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error parsing JWT token:', error);
    return null;
  }
};

/**
 * Verifies if user is authenticated with a valid token
 * @returns {boolean} True if user has valid authentication, false otherwise
 */
export const isAuthenticated = () => {
  const loginInfo = localStorage.getItem('LoginInfo');
  const token = localStorage.getItem('Token');

  console.log('isAuthenticated check:', {
    hasLoginInfo: !!loginInfo,
    hasToken: !!token
  });

  // Check if both login info and token exist
  if (!loginInfo || !token) {
    return false;
  }

  // Check if token is expired
  return !isTokenExpired();
}; 